import withAPIAction from 'helpers/withAPIAction'
import {
  QuotationListReq,
  CreateQuotationReq,
  UpdateQuotationReq,
  DeleteQuotationReq,
  QuotationDetailReq,
  UpdateQuotationStatusReq,
  CustomerReq,
  UpdateGrnReq,
} from './types'
import {
  getQuotationListAction,
  createQuotationAction,
  updateQuotationAction,
  deleteQuotationAction,
  getQuotationDetailAction,
  updateQuotationStatusAction,
  getCustomerAction,
  updateGrnQuotationAction,
  getCountAction,
} from './actions'
import { APIPath } from 'services/APIPath'
import { appConfig } from 'config'
import { getRequestString } from 'helpers/format'

export const quotationListAPI = (data: QuotationListReq, token: string, xmid: string) => {
  return withAPIAction<QuotationListReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.quotationList}`,
    data,
    token,
    xmid,
  })(getQuotationListAction)
}

export const createQuotationAPI = (data: CreateQuotationReq, token: string, xmid: string) => {
  return withAPIAction<CreateQuotationReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.createQuotation,
    data,
    token,
    xmid,
  })(createQuotationAction)
}

export const updateQuotationAPI = (data: UpdateQuotationReq, token: string, xmid: string) => {
  const endPoint = APIPath.updateQuotation.replace(':id', data.id.toString())
  return withAPIAction<UpdateQuotationReq>({
    method: 'PUT',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(updateQuotationAction)
}

export const deleteQuotationAPI = (data: DeleteQuotationReq, token: string, xmid: string) => {
  const endPoint = APIPath.deleteQuotation.replace(':id', data.id.toString())
  return withAPIAction<DeleteQuotationReq>({
    method: 'DELETE',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(deleteQuotationAction)
}

export const getQuotationDetailAPI = (data: QuotationDetailReq, token: string, xmid: string) => {
  const endPoint = APIPath.getQuotationByID.replace(':id', data.id.toString())
  return withAPIAction<QuotationDetailReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(getQuotationDetailAction)
}

export const updateQuotationStatusAPI = (data: UpdateQuotationStatusReq, token: string, xmid: string) => {
  const endPoint = APIPath.updateQuotationStatus.replace(':id', data.id.toString())
  return withAPIAction<UpdateQuotationStatusReq>({
    method: 'PUT',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(updateQuotationStatusAction)
}

export const getCustomerAPI = (data: CustomerReq, token: string, xmid: string) => {
  return withAPIAction<CustomerReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.quotationCustomerList}?${getRequestString(data)}`,
    data,
    token,
    xmid,
  })(getCustomerAction)
}

export const updateGrnQuotationAPI = (data: UpdateGrnReq, token: string, xmid: string) => {
  const endPoint = APIPath.updateGrnQuotation.replace(':id', data.id.toString())
  return withAPIAction<UpdateGrnReq>({
    method: 'PUT',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(updateGrnQuotationAction)
}

export const getCountQuotationPI = (data: {}, token: string, xmid: any) => {
  return withAPIAction<{}>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.countQuotation}`,
    data,
    token,
    xmid,
  })(getCountAction)
}
